import { info } from './getPublisher'
import { list } from './list'
import { listReport } from './listReport'

export default {
  ...list,
  ...listReport,
  ...info
}
